var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbPageIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M27.5195 10.3895C27.9976 9.71194 29.0024 9.71194 29.4805 10.3895L50.9807 40.8581C51.5416 41.653 50.9731 42.75 50.0002 42.75H6.99977C6.02687 42.75 5.45837 41.653 6.0193 40.8581L27.5195 10.3895Z",
    fill: "#33CCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 52.25H52.25",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1562 9.5V52.25H33.8438V9.5C33.8438 6.8875 32.775 4.75 29.5687 4.75H27.4313C24.225 4.75 23.1562 6.8875 23.1562 9.5Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 23.75V52.25H16.625V23.75C16.625 21.1375 15.675 19 12.825 19H10.925C8.075 19 7.125 21.1375 7.125 23.75Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 35.625V52.25H49.875V35.625C49.875 33.0125 48.925 30.875 46.075 30.875H44.175C41.325 30.875 40.375 33.0125 40.375 35.625Z",
    stroke: "#0C111D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbPageIcon03);
export default __webpack_public_path__ + "static/media/ab-page-icon03.2d557c0a1b8db6aa28ae4643fda7eb12.svg";
export { ForwardRef as ReactComponent };